import { SyntheticEvent } from 'react';

interface PaginationHookProps {
  onPageChange: VoidFunction;
  hasNextPage?: boolean;
}

const useInfiniteScroll = ({ onPageChange, hasNextPage }: PaginationHookProps) => {
  // I add console logs for testing, because pagination is not working for some devices
  const handleScroll = (event?: SyntheticEvent) => {
    console.log('Event Empty');
    if (!event) return;
    const listboxNode = event.target as HTMLElement;
    const bottom = listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 70;
    console.log({ hasNextPage, bottom });
    if (bottom && hasNextPage) {
      console.log('Nasa bottom na at may next page');
      onPageChange();
    }
  };

  return {
    handleScroll,
  };
};

export default useInfiniteScroll;
